<template>
  <div class="user_profile">
    <section class="text_center no_padding">
      <h2 class="header_underline">プロフィール設定</h2>
      <div class="user_profile_update_success" v-if="isProfileUpdateSuccess || isNoticeMailChangeSuccess">
        <span v-if="isProfileUpdateSuccess">※鑑定基本情報を更新しました</span>
        <span v-if="isNoticeMailChangeSuccess">※設定を更新しました</span>
      </div>

      <div class="user_profile_wrap">
        <div class="user_profile_box user_profile_info">
          <h3>鑑定基本情報</h3>
          <table class="text_left">
            <tr>
              <th>ニックネーム</th>
              <td><span class="user_profile_info_separator"></span></td>
              <td>{{ user.user.nickname }}</td>
            </tr>
            <tr>
              <th>会員ID</th>
              <td><span class="user_profile_info_separator"></span></td>
              <td>{{ user.user.id }}</td>
            </tr>
            <tr>
              <th>血液型</th>
              <td><span class="user_profile_info_separator"></span></td>
              <td>{{ bloodType }}</td>
            </tr>
            <tr>
              <th>生まれた月</th>
              <td><span class="user_profile_info_separator"></span></td>
              <td>{{ birthMonth }}月</td>
            </tr>
            <tr>
              <th>星座</th>
              <td><span class="user_profile_info_separator"></span></td>
              <td>{{ horoscope }}</td>
            </tr>
          </table>
          <router-link :to="{ name: 'UserProfileChange' }" class="btn arrow">鑑定基本情報を変更する</router-link>
        </div>

        <div class="user_profile_box user_profile_settings">
          <h3>各種設定</h3>
          <p class="user_profile_settings_overview">メールアドレスの変更・登録はこちら</p>
          <router-link :to="{ name: 'UserMailChange' }" class="btn arrow">メールアドレス変更・登録</router-link>
          <p class="user_profile_settings_overview" v-if="user.user.mail.length > 0">鑑定結果が届いた際や、キャンペーン開催時などに<br>お知らせする【お知らせメール】の受信・非受信設定はこちら</p>
          <router-link :to="{ name: 'UserMailSettings' }" class="btn arrow" v-if="user.user.mail.length > 0">お知らせメール受信設定</router-link>
          <p class="user_profile_settings_note">設定変更にてご不明点がありましたら<a :href="`mailto:${settingData.inquiry_mail}?subject=設定変更について[${user.user.id}]`" class="link_main--text text-decoration-underline">コチラ</a>までご連絡ください</p>
        </div>
      </div>
    </section>
    <section class="user_profile_link text_center">
      <router-link to="/" class="arrow link_main--text">トップページへ戻る</router-link>
    </section>
  </div>
</template>

<script>
import moment from 'moment'
import {
  BLOOD_TYPE,
  HOROSCOPES
} from '@/helper/constant'

export default {
  name: 'UserProfile',
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      info: this.$store.getters.siteInfo || null,
      settingData: []
    }
  },
  props: {
    isProfileUpdateSuccess: {
      type: Boolean,
      default: false
    },
    isNoticeMailChangeSuccess: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    loginUser () {
      return this.$store.getters.loginUser
    },
    siteInfo () {
      return this.$store.getters.siteInfo
    },
    birthMonth () {
      if (this.user.user.birthday != null) {
        const birthday = this.user.user.birthday.replaceAll('/', '-')
        const m = moment(birthday)
        return m.month() + 1
      } else {
        return ''
      }
    },
    bloodType () {
      if (this.user.user.blood_type != null) {
        return BLOOD_TYPE.find(g => g.value === this.user.user.blood_type).label
      } else {
        return '未設定'
      }
    },
    horoscope () {
      if (this.user.user.birthday != null) {
        const birthday = this.user.user.birthday.replaceAll('/', '-')
        const m = moment(birthday)
        // 月日を4桁の数値にする 1/31 -> 131
        const birthMonthAndDay = ((m.month() + 1) * 100) + m.date()
        let horo = HOROSCOPES.find(g => g.value >= birthMonthAndDay)
        if (typeof horo === 'undefined') {
          horo = HOROSCOPES[0]
        }
        return horo.label
      } else {
        return ''
      }
    }
  },
  watch: {
    loginUser (val, old) {
      this.user = val
    },
    siteInfo (val, old) {
      this.info = val
    }
  },
  methods: {
    getDefaultSetting () {
      this.$store.dispatch('getDefaultSetting')
        .then((data) => {
          this.settingData = data
        })
    }
  },
  created () {
    this.getDefaultSetting()
  }
}
</script>
